import { render, staticRenderFns } from "./GalleryRecipe2.vue?vue&type=template&id=25677314&"
import script from "./GalleryRecipe2.vue?vue&type=script&lang=js&"
export * from "./GalleryRecipe2.vue?vue&type=script&lang=js&"
import style0 from "./GalleryRecipe2.vue?vue&type=style&index=0&id=25677314&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports